import React from 'react';

const CommunicationsTab = () => {
  return (
    <div>
      <h2>Internal Communications</h2>
      {/* Add communications content */}
    </div>
  );
};

export default CommunicationsTab; 